export default "__VITE_ASSET__e3a45283__"